export { default } from './AddPromo.vue';
